'use client'
import ThreeStars from '@/components/svgs/ThreeStarsSvg/threeStars'
import { Button } from '@/components/ui/button'
import { Modal } from '@/components/ui/modal'
import { Center, Fieldset, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import Heart from '../../_components/sections/hero/svgs/Heart'

const MAX_CHARACTERS = 500

interface MyHistoryProps {
	about: string
	title: string
}

function MyHistory({ about, title }: MyHistoryProps) {
	const [opened, { open, close }] = useDisclosure(false)

	const truncateText = (text: string, maxLength: number) => {
		if (text.length <= maxLength) {
			return text
		}
		return `${text.substring(0, maxLength)}...`
	}

	return (
		<>
			<Fieldset
				flex="1 1 50%"
				bg="white"
				variant="filled"
				styles={{ legend: { marginLeft: 'auto', marginRight: 'auto' }, root: { borderColor: 'white' } }}
				legend={<Title>{title}</Title>}
				style={{ whiteSpace: 'pre-wrap', position: 'relative' }}
				className="text-black text-lg min-h-[650px] max-h-[650px] md:min-h-[480px] md:max-h-[480px]"
			>
				{truncateText(about, MAX_CHARACTERS)}
				<Center>
					{about.length > MAX_CHARACTERS && (
						<Button size="md" onClick={() => open()}>
							Ver mais
						</Button>
					)}
				</Center>
			</Fieldset>

			<Heart className="absolute right-4 top-78 max-w-[5%] transform translate-x-[-5.68434e-14px] translate-y-[-2.84217e-14px] rotate-[20deg]" />
			<Heart className="absolute -left-24 bottom-80 max-w-[5%] transform translate-x-[-5.68434e-14px] translate-y-[-2.84217e-14px] rotate-[340deg]" />
			<ThreeStars className="absolute right-0 bottom-4 max-w-[8%]" />
			<Modal opened={opened} onClose={() => close()} title={title}>
				{about}
			</Modal>
		</>
	)
}

export default MyHistory
